import React, { memo, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import AutoSizer from "react-virtualized-auto-sizer";
import { isMobile } from "react-device-detect";

import IndustryPriceRatioChangeChart from "./IndustryPriceRatioChangeChart";
import IDXNumberStockChart from "../index-components/IDXNumberStockChart";
import IDXValueScaleChart from "../index-components/IDXValueScaleChart";
import IndustryForeignQttyScale from "./IndustryForeignQttyScale";

import { priceToNumber, signNumber, formatNumber, formatNumber_N1, formatNumberToB_N1 } from "../../helpers/utils";
import clsx from "clsx";
import { useAxios } from "../../helpers/apiHelper";

export default memo(
  function IndustryIndexNormalViewTable(props) {
    // const { industryCode } = props;
    const { t } = useTranslation();
    const popupConfig = useSelector((state) => state.gShared.popupConfig);
    const groupSymbol = useSelector((state) =>
      state.gShared.industries.find(
        (e) =>
          (popupConfig.type === "ST" && e.symbolList.indexOf(popupConfig.code) >= 0) || (popupConfig.type === "IND" && e.code === popupConfig.code)
      )
    );
    const industryCode = groupSymbol?.code;
    const i_counter = useSelector((state) => state.gIndex.indexInfos.find((e) => e.indexCode === industryCode)?.counter);
    const industryIndex = useSelector((state) => state.gIndex.indexInfos.find((e) => e.indexCode === industryCode));
    const _priceRatioChange = priceToNumber(industryIndex?.priceRatioChange);
    const _colorClass = _priceRatioChange > 0 ? "clr-up" : _priceRatioChange < 0 ? "clr-down" : "clr-ref";

    //
    return (
      <>
        <table className="tb-popup-detail mr-bottom_15">
          <thead>
            <tr>
              <th>Room còn lại NĐTNN</th>
              <th>P/E cơ bản</th>
              <th>P/E pha loãng</th>
              <th>P/B</th>
              <th>EPS cơ bản(12 tháng)</th>
              <th>EPS pha loãng(12 tháng)</th>
              <th>Giá trị sổ sách</th>
              <th>Lợi tức gần nhất(Cổ tức TM/Giá) </th>
              <th>ROE </th>
              <th>ROA </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{props?.inforBasic?.CurrentForeignRoom?.toFixed(2)}</td>
              <td>{props?.inforBasic?.BasicPE_LFY?.toFixed(2)}</td>
              <td>{props?.inforBasic?.DilutedPE?.toFixed(2)}</td>
              <td>{props?.inforBasic?.PB?.toFixed(2)}</td>
              <td>{props?.inforBasic?.BasicEPS_LFY?.toFixed(2)}</td>
              <td>{props?.inforBasic?.DilutedEPS_LFY?.toFixed(2)}</td>
              <td>{props?.inforBasic?.BookValuePerShare?.toFixed(2)}</td>
              <td>{props?.inforBasic?.DividentYield?.toFixed(2)}</td>
              <td>{props?.inforBasic?.ROE_LFY?.toFixed(2)}%</td>
              <td>{props?.inforBasic?.ROA_LFY?.toFixed(2)}%</td>
            </tr>
          </tbody>
        </table>
      </>
    );
  },
  (prevProps, nextProps) => {
    if (prevProps.industryCode === nextProps.industryCode) {
      return true;
    }
    return false;
  }
);
